export const Size = {
  COMPACT: 'COMPACT',
  LARGE: 'LARGE',
};

const PrizeTierBadgeAndTitle = ({ title, subtitle, badge, size = Size.COMPACT }) => {
  return (
    <div className="badgeAndTitleContainer">
      <div className="badgeImageContainer">
        <img src={badge} alt="" className="badgeImage" />
      </div>

      <p className="title">
        {title} {subtitle && <span className="subtitle">{subtitle}</span>}
      </p>

      <style jsx>
        {`
          .badgeAndTitleContainer {
            display: flex;
          }

          .badgeImageContainer {
            width: ${size === Size.LARGE ? 50 : 35}px;
            height: ${size === Size.LARGE ? 50 : 35}px;
            display: flex;
            align-items: center;
            margin-right: 0.2em;
          }

          .badgeImage {
            height: ${size === Size.LARGE ? 40 : 30}px;
            max-width: 100%;
          }

          .title {
            text-transform: uppercase;
            font-weight: 700;
            font-family: 'Montserrat', sans-serif;
            font-size: 1.1rem;
            align-self: center;
            text-align: left;
            line-height: 1;
            max-width: 100px;
          }

          .subtitle {
            text-transform: none;
            font-weight: 300;
            font-style: italic;
            font-size: 0.85em;
          }
        `}
      </style>
    </div>
  );
};

export default PrizeTierBadgeAndTitle;
